import { render, staticRenderFns } from "./BmiPlot.vue?vue&type=template&id=74bff019&scoped=true&"
import script from "./BmiPlot.vue?vue&type=script&lang=js&"
export * from "./BmiPlot.vue?vue&type=script&lang=js&"
import style0 from "./BmiPlot.vue?vue&type=style&index=0&id=74bff019&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bff019",
  null
  
)

export default component.exports